<template>
  <img v-if="src && !gagal" :src="src" :alt="nama" class="avatar-foto" :style="ukuran" @error="gagal = true" />
  <span v-else class="avatar-foto avatar-inisial" :style="{ ...ukuran, fontSize: size * 0.4 + 'px' }" :title="nama">{{ teks }}</span>
</template>

<script>
// Foto profil bulat; tanpa foto (atau gagal dimuat) tampil inisial nama
import { fotoUrl, inisial } from '@/utils/foto'

export default {
  name: 'AvatarFoto',
  props: {
    foto: { type: String, default: '' }, // path relatif dari API
    nama: { type: String, default: '' },
    size: { type: Number, default: 32 },
  },
  data() {
    return { gagal: false }
  },
  computed: {
    src() {
      return fotoUrl(this.foto)
    },
    teks() {
      return inisial(this.nama)
    },
    ukuran() {
      return { width: this.size + 'px', height: this.size + 'px' }
    },
  },
  watch: {
    foto() {
      this.gagal = false
    },
  },
}
</script>

<style scoped>
.avatar-foto {
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  display: inline-block;
  vertical-align: middle;
}
.avatar-inisial {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--cui-primary, #321fdb);
  color: #fff;
  font-weight: 600;
  line-height: 1;
}
</style>
